export class FindAccountAssociation {
    id: number;
    registrationId: number;
    
    constructor() {
        this.id = 0;
        this.registrationId = 0;
    }
}